const styles = {
    inputAdornment: {
        marginRight: '18px',
        top: '18px',
        position: 'relative',
    },
    inputAdornmentIcon: {
        color: '#555'
    },
    customFormControlClasses: {
        margin: '0 12px'
    },
};

export default styles;



// WEBPACK FOOTER //
// ./src/common/Form/styles.js